import { useEffect, useState } from 'react';
import { messagingApi } from '../api/messaging';
import { hasCapability } from '../utils/auth';
import { useModules } from '../hooks/useModules';

// [step 1.19] First unread/badge mechanism anywhere in the frontend — a
// standalone component rather than shoehorned into Navbar, per § Approach
// item 9's explicit "should be built as a small standalone component" note.
// P1 has no WS (step 1.17) so this polls GET /unread on the same interval
// Messages.tsx uses.
const UNREAD_POLL_INTERVAL_MS = 15_000;

export default function UnreadBadge() {
  const { hasModule } = useModules();
  const [totalUnread, setTotalUnread] = useState(0);
  const [hasMention, setHasMention] = useState(false);

  const enabled = hasModule('messaging') && hasCapability('view_messaging');

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    function poll() {
      messagingApi.getUnread()
        .then(res => {
          if (cancelled) return;
          setTotalUnread(res.total_unread);
          setHasMention(res.has_any_mention);
        })
        .catch(() => {});
    }
    poll();
    const timer = setInterval(poll, UNREAD_POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(timer); };
  }, [enabled]);

  if (!enabled || totalUnread <= 0) return null;

  return (
    <span
      data-testid="unread-badge"
      aria-label={`${totalUnread} unread message${totalUnread === 1 ? '' : 's'}`}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        minWidth: 16, height: 16, padding: '0 4px', borderRadius: 8,
        fontSize: 10, fontWeight: 700, lineHeight: 1,
        background: hasMention ? 'var(--danger)' : 'var(--accent)', color: '#fff',
        marginLeft: 4, flexShrink: 0,
      }}
    >
      {totalUnread > 99 ? '99+' : totalUnread}
    </span>
  );
}
